// extracted by mini-css-extract-plugin
export default {"card":"PaymentMethod_card__MyHKG","table":"PaymentMethod_table__wVGBF"};